<template>
    <div>
      <!-- Pasa la prop solo si la copia está completa -->
      <TableComponent v-if="isCopyComplete" :items="localItemsArray" :columns="columns" @nextModal="nextModal" ref="tableData" />
    </div>
  </template>

<script>
import TableComponent from './table.vue'

export default {
  components: {
    TableComponent,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      columns: ['ID Banner', 'Cédula', 'Nombres', 'Período', 'Operador Consolidado', 'Operador Banner', 'Operador Real'],
      localItemsArray: [],
      isCopyComplete: false, // Indica si se completó la copia
    }
  },
  mounted () {
    this.localItems()
  },
  methods: {
    localItems () {
      this.localItemsArray = this.items.map(item => ({
        ...item, // Copia las propiedades existentes
        operadorReal: '', // Añade la nueva propiedad
      }))
      this.isCopyComplete = true // Marca que la copia se completó
    },
    callTableSon () {
      this.$refs.tableData.sendDataOperators()
    },
    nextModal(){
      this.$emit('nextModal')
    }
  },
}
</script>